var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._t("default"),_c('Advert',{attrs:{"adType":"pageIntro"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }